<template>
	<div>
		<el-dialog title="添加课程" width="800px" class="icon-dialog" :visible.sync="show" @open="open"
			:before-close="closeForm" append-to-body>
			<el-form :size="size" ref="form" :model="form" :inline="true" >
				<el-row>
					<el-col :span="24">
						<el-form-item label="课程名称" prop="title">
							<el-input v-model="form.title" autoComplete="off" clearable placeholder="请输入课程名称"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="课程介绍" prop="title">
							<el-input  type="textarea" v-model="form.detail" autoComplete="off" clearable placeholder="请输入课程介绍"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="课程标签" prop="title">
							<el-input v-model="form.label" autoComplete="off" clearable placeholder=" 每个标签用#隔开"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="课程价格" prop="title">
							<el-input style="width: 160px;" v-model="form.price" autoComplete="off" clearable placeholder="请输入课程价格"></el-input>
						</el-form-item>
						<el-form-item label="折扣价格" prop="title">
							<el-input style="width: 160px;" v-model="form.discount_price" autoComplete="off" clearable placeholder="请输入折扣价格"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="所属讲师">
					<el-select style="width: 160px;" size="small" v-model="form.lid" placeholder="请选择">
						<el-option v-for="type in lidlist" :label="type.lecturer_name" :value="type.lid"
							:key="type.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属产品">
					<el-select style="width: 160px;" size="small" v-model="form.apid" placeholder="请选择">
						<el-option v-for="type in apidlist" :label="type.name" :value="type.apid"
							:key="type.value"></el-option>
					</el-select>
				</el-form-item>
				<el-row>
					<el-form-item label="课程状态" prop="type">
						<el-radio-group v-model="form.type">
							<el-radio :label="0">待完结</el-radio>
							<el-radio :label="1">已完结</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="所属平台" prop="is_platform" style="margin-left: 30px;">
						<el-radio-group v-model="form.is_platform">
							<el-radio :label="0">抖音</el-radio>
							<el-radio :label="1">快手</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-row>
				<el-row>
					<el-form-item label="列表图">
						<el-upload class="avatar-uploader" :action="updatehttp" :headers="headers" :data="updata"
							accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP" :show-file-list="false"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							<el-image v-if="form.list_img" class="avatar" :src="form.list_img"></el-image>
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="课程详情图">
						<el-upload class="avatar-uploader" :action="updatehttp" :headers="headers" :data="updata"
							accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP" :show-file-list="false"
							:on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload">
							<el-image v-if="form.course_img" class="avatar1" :src="form.course_img"></el-image>
							<i v-else class="el-icon-plus avatar-uploader-icon1"></i>
						</el-upload>
					</el-form-item>

				</el-row>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit">
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getAddCourse,getAgentProduct,getAgentLecturer } from '../../api/userMG';
export default {
	name: 'Add',
	components: {
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
	},
	data() {
		return {
			updatehttp: '/lecturer/putFile',
			headers: {
				token: localStorage.getItem('logintoken')
			},
			apidlist: [],
			lidlist:[],
			form: {
				apid:'',
				lid:'',
				title: '',
				type:0,
				is_platform:0,
				list_img:'',
				course_img:'',
				detail:'',
				price:'',
				discount_price:'',
				label:''
			},
			editorOption: {
			},
			loading: false,
			rules: {
			},
			updata:{
				file_name:0
			},
			userinfo:{}
		}
	},
	created() {
		this.userinfo = JSON.parse(localStorage.getItem('userdata'))
		console.log(this.userinfo.Permissions_type);
	},
	methods: {
		handleAvatarSuccess(res, file) {
			this.form.list_img = res.img_url.substring(0,res.img_url.lastIndexOf("?"));
		},
		beforeAvatarUpload(file) {
		},
		handleAvatarSuccess1(res, file) {
			this.form.course_img = res.img_url.substring(0,res.img_url.lastIndexOf("?"));
		},
		open() {
			getAgentLecturer().then(res=>{
				this.lidlist = res.info
			})
			getAgentProduct().then(res => {
				this.apidlist = res.info
			})
		},
		submit() {
			console.log(this.form);
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true
					getAddCourse(this.form).then(res => {
						console.log(res.code);
						if (res.code == 200) {
							this.$message({ message: '操作成功', type: 'success' })
							this.$emit('refesh_list')
							this.closeForm()
						} else {
							this.$message({ message: res.msg, type: 'error' })
							this.loading = false
						}
					}).catch(() => {
						this.loading = false
					})
				}
			})
		},
		closeForm() {
			this.$emit('update:show', false)
			this.loading = false
			this.form = {
				lecturer_name: '',
				trainer_user_id: '',
				face: '',
				introduce: '',
				phone: '',
				pass: '',
				dy_number: '',
				ks_number: ''
			}
			if (this.$refs['form'] !== undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>
<style scoped >
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 100px;
	line-height: 100px;
	text-align: center;
	border: 1px solid #dadcdf;
	margin-top: 10px;
	border-radius: 10px;
}

.avatar {
	width: 100px;
	height: 100px;
	display: block;
	border: 1px solid #dadcdf;
}

.avatar1 {
	width: 200px;
	height: 300px;
	display: block;
	border: 1px solid #dadcdf;
}

.avatar-uploader-icon1 {
	font-size: 28px;
	color: #8c939d;
	width: 200px;
	height: 300px;
	line-height: 300px;
	text-align: center;
	border: 1px solid #dadcdf;
	margin-top: 10px;
	border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/course/add.vue